/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import { filter } from 'lodash';

import {
  REQUESTED_REFRESH_EXTERNAL_INVESTMENT_BALANCES,
  RECEIVED_EXTERNAL_INVESTMENT_BALANCES,
  RECEIVED_REFRESH_EXTERNAL_INVESTMENT_BALANCES,
  REQUESTED_EXTERNAL_INVESTMENT_BALANCES
} from 'state/external/ExternalInvestmentBalancesActions';

export const externalInvestmentRequestTimeReducer = (
  state = null,
  { time, type }
) =>
  type === REQUESTED_EXTERNAL_INVESTMENT_BALANCES ||
  type === REQUESTED_REFRESH_EXTERNAL_INVESTMENT_BALANCES
    ? time
    : state;

export const externalInvestmentBalancesReducer = (
  state = null,
  { type, investments }
) => {
  if (
    type === RECEIVED_EXTERNAL_INVESTMENT_BALANCES ||
    type === RECEIVED_REFRESH_EXTERNAL_INVESTMENT_BALANCES
  ) {

    // remove investments that are TRP investments by checking external flag
    return filter(investments, (i) => i.external);
  }
  return state;
};
